export const HEARTBEAT_DE = {
  heartbeat: 'Agent',
  heartbeatDescription: 'Geplante Aufgaben überwachen und verwalten',
  createMonitor: 'Monitor erstellen',
  editMonitor: 'Monitor bearbeiten',
  deleteMonitor: 'Monitor löschen',
  monitorName: 'Name',
  monitorDescription: 'Beschreibung',
  taskType: 'Aufgabentyp',
  taskQuery: 'Aufgabenabfrage',
  taskQueryPlainLanguageHint:
    'E-Mails werden standardmäßig auf Deutsch und verständlich für nicht-technische Leser formuliert (klare Zusammenfassung, Auswirkung und nächste Schritte).',
  modelSelectPlaceholder: 'Modell auswählen',
  modelLoading: 'Verfügbare Modelle werden geladen...',
  modelLoadFailed:
    'Modellliste nicht verfügbar. Speichern ist deaktiviert, bis Modelle geladen sind.',
  modelFallbackHint:
    'Keine auswählbaren Modelle gefunden. Speichern ist deaktiviert, bis ein Modell verfügbar ist.',
  heartbeatWebSearchEnabled: 'Websuche aktivieren',
  webSearchEnabledHint: 'Wenn deaktiviert, läuft Agent ohne Web-Grounding.',
  schedulePreset: 'Zeitplan-Vorlage',
  presetEvery15Minutes: 'Alle 15 Minuten',
  presetHourly: 'Stündlich',
  presetEvery4Hours: 'Alle 4 Stunden',
  presetDaily: 'Täglich',
  presetWeekdays: 'Werktags (Mo-Fr)',
  presetWeekly: 'Wöchentlich',
  presetCustom: 'Benutzerdefiniert',
  weeklyDay: 'Wochentag',
  weekdayMon: 'Montag',
  weekdayTue: 'Dienstag',
  weekdayWed: 'Mittwoch',
  weekdayThu: 'Donnerstag',
  weekdayFri: 'Freitag',
  weekdaySat: 'Samstag',
  weekdaySun: 'Sonntag',
  scheduleType: 'Zeitplantyp',
  intervalMinutes: 'Intervall (Minuten)',
  cronExpression: 'Cron-Ausdruck',
  cronExpressionHint:
    'Verwenden Sie das 6-teilige Spring-Cron-Format: Sek Min Std Tag Monat Wochentag.',
  timeOfDay: 'Tageszeit',
  timezone: 'Zeitzone',
  outputChannel: 'Versandkanal',
  outputTargetEmail: 'Versand-E-Mail',
  outputTargetEmailHint: 'Agent-Ergebnisse werden an Ihre Account-E-Mail gesendet.',
  outputTargetEmailUnavailable:
    'Keine Account-E-Mail gefunden. Hinterlegen Sie eine Account-E-Mail, um speichern zu können.',
  outputTargetEmailInvalid: 'Bitte eine gültige E-Mail-Adresse eingeben.',
  enabled: 'Aktiviert',
  paused: 'Pausiert',
  active: 'Aktiv',
  currentlyExecuting: 'Wird gerade ausgeführt',
  lastExecution: 'Letzte Ausführung',
  nextScheduled: 'Nächste geplante Ausführung',
  nextRunNow: 'Nächste Ausführung jetzt',
  nextRunInMinutes: 'Nächste Ausführung in {count} Min.',
  nextRunInHours: 'Nächste Ausführung in {count} Stunde(n)',
  nextRunInDays: 'Nächste Ausführung in {count} Tag(en)',
  executeNow: 'Jetzt ausführen',
  pauseMonitor: 'Pausieren',
  resumeMonitor: 'Fortsetzen',
  noMonitors: 'Noch keine Agenten',
  noMonitorsDescription: 'Erstellen Sie einen Agenten, um geplante Aufgaben zu verfolgen',
  searchMonitors: 'Agenten durchsuchen...',
  noMonitorsFound: 'Keine Agenten gefunden',
  clearSearch: 'Suche löschen',
  confirmDeleteMessage:
    'Sind Sie sicher, dass Sie diesen Monitor löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  monitorCreated: 'Monitor erfolgreich erstellt',
  monitorUpdated: 'Monitor erfolgreich aktualisiert',
  monitorDeleted: 'Monitor erfolgreich gelöscht',
  monitorPaused: 'Monitor pausiert',
  monitorResumed: 'Monitor fortgesetzt',
  executionTriggered: 'Ausführung ausgelöst',
  research: 'Recherche',
  geo: 'Geo',
  generation: 'Generierung',
  interval: 'Intervall',
  cron: 'Cron',
  dailyAt: 'Täglich um',
  everyNMinutes: 'Alle {count} Min.',
  create: 'Erstellen',
  executionHistory: 'Ausführungsverlauf',
  executionResult: 'Ausführungsergebnis',
  noExecutions: 'Noch keine Ausführungen',
  noExecutionsDescription: 'Dieser Monitor wurde noch nicht ausgeführt',
  executionRun: 'Lauf {count}',
  resultPreviewUnavailable:
    'Keine Ergebnisvorschau verfügbar. Öffnen Sie den Lauf für die volle Ausgabe.',
  viewFullResult: 'Vollständiges Ergebnis anzeigen',
  executionDetails: 'Ausführungsdetails',
  executionStatus: 'Status',
  statusStart: 'Gestartet',
  statusSent: 'Gesendet',
  statusStep: 'Schritt',
  statusRunning: 'Laufend',
  statusInProgress: 'In Bearbeitung',
  statusPending: 'Ausstehend',
  statusFinished: 'Abgeschlossen',
  statusDone: 'Erledigt',
  statusCompleted: 'Abgeschlossen',
  statusSuccess: 'Erfolgreich',
  statusSucceeded: 'Erfolgreich',
  statusError: 'Fehler',
  statusFailed: 'Fehlgeschlagen',
  statusFailure: 'Fehler',
  statusNeverRun: 'Nie ausgeführt',
  statusQueued: 'In Warteschlange',
  statusCancelled: 'Abgebrochen',
  statusTimeout: 'Zeitüberschreitung',
  statusSkipped: 'Übersprungen',
  statusDelivered: 'Zugestellt',
  executionTrigger: 'Auslöser',
  executionStart: 'Gestartet',
  executionEnd: 'Beendet',
  resultTab: 'Ergebnis',
  addResultToEditor: 'Zum Editor hinzufügen',
  sourcesTab: 'Quellen',
  statsTab: 'Statistik',
  resultUnavailable: 'Für diese Ausführung liegt kein Ergebnis vor.',
  sourcesUnavailable: 'Für diese Ausführung sind keine Quellen verfügbar.',
  resultTruncated: '[Ergebnis zur besseren Lesbarkeit gekürzt]',
  citationCount: 'Quellenanzahl',
  deliveryStatus: 'Zustellstatus',
  deliveryTime: 'Zustellzeit',
  deliveryError: 'Zustellfehler',
  notAvailable: 'Nicht verfügbar',
  changeSummary: 'Änderungszusammenfassung',
  citations: 'Quellenangaben',
  errorMessage: 'Fehler',
  scheduled: 'Geplant',
  manual: 'Manuell',
  backToMonitors: 'Zurück zu Monitoren',
  viewExecutions: 'Ausführungen anzeigen',
  totalCost: 'Gesamtkosten'
}
